import { ArrowRight } from "@phosphor-icons/react"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import NextLink from "next/link"
import type { products } from "@/constants/content"

export const NavProducts = ({ products: incomingProducts }: { products: typeof products }) => {
  return (
    <div className="flex items-center gap-2">
      {incomingProducts.map((solution, _index) => {
        const VisualComponent = (solution as any).navVisual || solution.visual

        return (
          <NextLink
            key={solution.name}
            href={solution.ctaHref}
            className="group w-[160px] p-3 rounded-lg relative overflow-hidden transition-[background-color_200ms] hover:bg-neutral-400/[0.07]"
          >
            <div className="flex flex-col gap-3" style={{ position: "relative" }}>
              <div className="flex flex-col gap-0.5">
                <div className="flex items-center justify-between">
                  <div className="font-medium text-sm">{solution.name}</div>
                  <Icon
                    as={ArrowRight}
                    className="w-3.5 h-3.5 shrink-0 text-fg-secondary opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                  />
                </div>
                <p className="text-xs text-fg-secondary">{solution.subheading}</p>
              </div>
              <div
                className="relative w-full h-[84px] opacity-50 group-hover:opacity-90 transition-opacity duration-200"
                style={
                  {
                    maskImage: "radial-gradient(circle at top left, black 20%, transparent 95%)",
                  } as React.CSSProperties
                }
              >
                <div className="absolute top-0 left-0">
                  <VisualComponent />
                </div>
              </div>
            </div>
          </NextLink>
        )
      })}
    </div>
  )
}

export default NavProducts
